var drawGaugeCanvas = {
	drawCanvas:function (domId,index,publishTime,$){
		var vm = this;
		var radius = 85;
		var c=document.getElementById(domId);
		var winDow = $(window).width();
		if (index>100) {
			index = 100
		}
		if(winDow <= 320){
			radius = 78;
		}
		$(window).resize(function(){
			if(winDow <= 320){
				radius = 78
			}
		});
		var divHeight = c.width/2;
		var winDow = $(window).width();
		var ctx=c.getContext("2d");
	    var pixelPoint={};
	    var level,levelColor,pixelPoint;
	    ctx.clearRect(0,0,216,216);
	    var perdec = 312/100;
	    var dec = 24+index*perdec;
	    pixelPoint.X=parseInt(divHeight-(radius-8)*Math.sin(Math.PI*dec/180));
	    pixelPoint.Y=parseInt(divHeight+(radius-8)*Math.cos(Math.PI*dec/180));
	    this.drawCircle(ctx,divHeight,radius-6);
	    levelColor = this.getRgbColor(c,ctx,pixelPoint);
	    //console.info(levelColor)
	    this.drawPointer(ctx,divHeight,dec,levelColor,radius);
	    //console.info(c.toDataURL("image/gif", 1));
	    return levelColor.color
	},
	d2Hex:function (d) {
	    var hex = Number(d).toString(16);//转换成16进制，少于两位补0
	    while (hex.length < 2) {
	        hex = "0" + hex;
	    }
	    //console.info(hex)
	    return hex.toUpperCase();
	},
	getRgbColor:function (c,ctx,point) {
		var vm = this;
	    var imageData = ctx.getImageData(0, 0, c.width, c.height);
	    var data = imageData.data;//画布像素数据数组rgba
	    //console.info(data)
	    var i = ((point.Y * c.width) + point.X) * 4;//计算选择位置像素在data中的下标
	    //console.info('i='+i)
	    var rgb = [], color = '#', objRgbColor = { "rgb": rgb, "color": color };
	    for (var j = 0; j < 3; j++) {
	        rgb.push(data[i + j]);
	        color += this.d2Hex(data[i + j]);
	    }
	    objRgbColor.color = color;
	    //console.info(objRgbColor);
	    return objRgbColor;
	},
	getCoordByRadians:function (center,radius,radians) {
        var coordinate = {
            x:'',
            y:''
        };
        coordinate.x =   center + radius * Math.cos(radians);
        coordinate.y =   center + radius * Math.sin(radians);
        return coordinate;
    },
    drawSector:function (ctx,center,radius,startAngle,endAngle,color1,color2,isTerminal) {
        ctx.beginPath();
        ctx.arc(center,center,radius,startAngle,endAngle);

        var gradStartCoord = this.getCoordByRadians(center,radius,startAngle);
        var gradEndCoord = this.getCoordByRadians(center,radius,endAngle);
        var LinearGrad1 = ctx.createLinearGradient(gradStartCoord.x,gradStartCoord.y,gradEndCoord.x,gradEndCoord.y);
        LinearGrad1.addColorStop(0,color1);
        LinearGrad1.addColorStop(1,color2);
        ctx.strokeStyle = LinearGrad1;     
        ctx.lineWidth = 13;
        if (isTerminal) {
            ctx.lineCap = 'round';
        }

        ctx.stroke();
    },
    drawPointer:function (ctx,divHeight,dec,levelColor,radius){
    	ctx.lineWidth = 2;
        ctx.translate(divHeight,divHeight);
        ctx.rotate(dec*Math.PI/180);
        ctx.strokeStyle=levelColor.color;
        ctx.beginPath();
        ctx.moveTo(0,radius-25);
        ctx.arc(0,radius-8,11,-68*Math.PI/180,248*Math.PI/180);
        ctx.closePath();
        ctx.stroke();
        ctx.fillStyle='#fff';
        ctx.fill();
        ctx.beginPath();
        ctx.arc(0,radius-8,5,0,2*Math.PI);
        ctx.stroke();
        ctx.fillStyle=levelColor.color;
        ctx.fill();
        ctx.fillStyle='#000';
        ctx.shadowBlur=0;
        ctx.rotate(-dec*Math.PI/180);
        ctx.translate(-divHeight,-divHeight);
    },
    drawCircle:function (ctx,center,radius) {
        this.drawSector(ctx,center,radius,0.6*Math.PI,1.05*Math.PI,'rgb(77,207,147)','rgb(225,242,65)',true);
        this.drawSector(ctx,center,radius,1.05*Math.PI,1.5*Math.PI,'rgb(225,242,65)','rgb(242,204,54)');
        this.drawSector(ctx,center,radius,1.5*Math.PI,1.95*Math.PI,'rgb(242,204,54)','rgb(237,139,57)');
        this.drawSector(ctx,center,radius,1.95*Math.PI,2.4*Math.PI,'rgb(237,139,57)','rgb(223,73,66)',true);
    },
}
export default drawGaugeCanvas


// WEBPACK FOOTER //
// ./src/components/util/drawGaugeCanvas.js